const VISIBLE_ELEMENT = /<(img|hr)\b/i;
const NON_BREAKING_SPACE = /&nbsp;|&#160;|&#x0*a0;/gi;

export const hasVisibleHtmlContent = (html: unknown): html is string => {
  if (!html || typeof html !== 'string') return false;
  if (VISIBLE_ELEMENT.test(html)) return true;

  return (
    html
      .replaceAll(/<[^>]*>/g, '')
      .replaceAll(NON_BREAKING_SPACE, ' ')
      .trim() !== ''
  );
};
